var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-shrink-0 font-medium leading-5 text-base mb-4 text-gray-900 pt-6 pr-2"},[_vm._v(" "+_vm._s(_vm.getLabel)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }